/**
 * Parwaaz backend — the demo Ed25519 signing key.
 *
 * Deterministic (derived from a fixed string) so seeded "already issued" cards verify against
 * the `demo` key entry in `config/tenant.json` without an office ever having generated a real
 * key. Never use this key outside the demo/dev environment.
 */
import * as ed from '@noble/ed25519';
import { sha256, sha512 } from '@noble/hashes/sha2';
import { utf8ToBytes } from '@noble/hashes/utils';
import { bytesToBase64Url } from '../adapters/memory/platform';

// @noble/ed25519 v2's sync API needs a synchronous sha512 wired in once per process.
if (!ed.etc.sha512Sync) {
  ed.etc.sha512Sync = (...messages: Uint8Array[]) => sha512(ed.etc.concatBytes(...messages));
}

const seed = sha256(utf8ToBytes('parwaaz-demo-key-seed'));
const publicKey = ed.getPublicKey(seed);

export const DEMO_KEY = {
  kid: 'demo',
  seedB64url: bytesToBase64Url(seed),
  publicKeyB64url: bytesToBase64Url(publicKey),
};
